module.exports = global["async"] = require("-!./async.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?async!./public/javascripts/async.js-exposed
// module id = 141
// module chunks = 0